import './annualSubscription.css';
import gbgc_form_img from '../../assets/images/gbgc_form_img.png';
import { signatureContext } from "../../context/context";
import { useContext } from 'react';
import { getFinancialYear } from '../global/helper';
 
const AnnualSubscription = (props) => {
    const {primaryDetails, adminDetails} = props;
    
    const signatureImg = useContext(signatureContext)
    const { label, startYear, endYear } = getFinancialYear();

    return (
        <>
            <div className="app-body margin-tb60">
                <div className="page">
                    <h3 className="center header-title margin-t5"><strong>THE GAEKWAD BARODA GOLF CLUB</strong></h3>
                    <hr className="cut-hr margin-tb20" />
                    <h3 className="center header-subtitle margin-t5"><strong>Annual Subscription Plans for {label}</strong></h3>
                    <hr className="cut-hr margin-tb20" />

                    <div className="member-info">
                        <table>
                            <tbody>
                                <tr>
                                    <td width={"25%"}><strong>MEMBER NAME:</strong></td>
                                    <td>{primaryDetails?.FirstName && primaryDetails?.LastName ?  primaryDetails.FirstName + ' ' + primaryDetails.LastName : ''}</td>
                                    <td rowSpan="2" className='text-right'>
                                        <img src={gbgc_form_img} alt="Member Photo" style={{ width: '100px', height: '100px' }} />
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>MEMBERSHIP NO.:</strong></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table className="subscription-table">
                        <thead> 
                            <tr>
                                <th>Sr. No</th>
                                <th>Code #</th>
                                <th>Subscription Plans #</th>
                                <th>Total Subsc. Amount in INR</th>
                                <th>Please select your plan</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontWeight: '600'}}>
                            <tr>
                                <td>1</td>
                                <td>GFP</td>
                                <td>GOLF FAMILY PLAN</td>
                                <td>70,000</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>ICP</td>
                                <td>INDIVIDUAL COMBO PLAN</td>
                                <td>50,000</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>FSRSP</td>
                                <td>FAMILY SWIM &amp; RACQUET SPORTS PLAN</td>
                                <td>31,000</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>ASF</td>
                                <td>ANNUAL SPORTS FEE PLAN</td>
                                <td>10,000</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>AGFP</td>
                                <td>ASSOCIATE INDIVIDUAL COMBO PLAN</td>
                                <td>20,000</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>AFSRSP</td>
                                <td>ASSOCIATE FAMILY SWIM &amp; RACQUET SPORTS PLAN</td>
                                <td>12,400</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                    <hr className="cut-hr" />
                    <ol className="subscription-notes">
                        <li>All charges are quoted in INR. Payment for the subscribed plan is to be done upfront.</li>
                        <li>As per our membership agreement Clause No. 16(B), Members who do not subscribe to any plan shall fall under the category of ANNUAL SPORTS FEE and shall be charged INR 10,000 for a year inc GST.
                            After opting ASF plan, if a member/dependant uses any facility of the club will be charged on a daily basis.</li>
                        <li>Swimming, gym & steam facility is included in all plans except ASF plan.</li>
                        <li>Family plans include, spouse & all children below 24 years.</li>
                        <li>Should a member/dependant wish to enroll in a coaching program, he/she must subscribe to the relevant sports plan.</li>
                        <li>All plans are for a period from 1<sup>st</sup> April {startYear} to 31<sup>st</sup> March {endYear}.</li>
                        {/* old */}
                        {/* <li>All plans are for a period from 1<sup>st</sup> April {startYear} to 31<sup>st</sup> March {endYear}.</li>
                        <li>Member's whose membership is due for renewal should first renew the membership and then subscribe to the plan.</li>
                        <li>Only golf memberships can subscribe to golf plans while members with club membership can subscribe to other plans.</li>
                        <li>It is Mandatory for every member to subscribe to any ONE plan. Please mark (X) in the selected plan column.</li>
                        <li>Any member failing to subscribe to any plan by 31 May 2023 will be put under default "ASF-2 Plan."</li>
                        <li>Golf Premium Plan has been introduced for golfers specially who wish to support the expansion of the golf course to 18 holes. Under this plan, all FCP-I facilities are available.</li>
                        <li>Pro-shop vouchers cannot be en-cashed against any of the annual subscription plans.</li>
                        <li>Payment for all plans to be done through the app or web portal gateway or send a crossed cheque in favor of "Gaekwad Baroda Golf Club."</li>
                        <li>All Members will be billed a monthly subscription of INR 175/- per month plus applicable GST.</li> */}
                    </ol>
                    <hr className="cut-hr"/>

                    <div className="footer-annual-sub">
                        <div className="footer-left-annual-sub margin-t20">
                            <p><strong>FORM PREPARED BY: JESSY POTHEN</strong></p>
                            <p><strong>DESPATCHED THROUGH EMAIL</strong></p>
                            <p><strong>DATE:</strong> { adminDetails?.AccountDate && moment(adminDetails.AccountDate).format('DD-MM-YYYY')}</p>
                        </div>
                        <div className="footer-right-annual-sub">
                            {(!!signatureImg) ? (
                            <div className="avatar__holder"
                                style={{
                                    backgroundImage: typeof signatureImg === 'object' && signatureImg instanceof Blob
                                        ? `url(${URL.createObjectURL(signatureImg)})`
                                        : `url(${signatureImg})`,
                                    width: "130px",
                                    height: "30px",
                                    marginLeft: '175px',
                                    backgroundSize: "cover",
                                    backgroundPosition: "center"
                                }}
                            ></div>
                            ) : (
                                <div style={{ width: "130px", height: "30px"}}></div>
                            )}                             
                            {/* {(signatureImg) ? 
                                <div className="signature-text" style={{ width: "130px", height: "35px", border: '1px solid #ddd',borderRadius: '4px',display: 'flex',alignItems: 'center',justifyContent: 'center',textAlign: 'center',overflow: 'hidden',fontSize: '1rem',marginLeft: '186px'}}>
                                    <strong>
                                        {signatureImg}
                                    </strong>
                                </div>                                 
                            : <div style={{ width: "130px", height: "30px"}}></div>} */}
                            <p><strong>SIGNATURE OF MEMBER:</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
  );
};

export default AnnualSubscription;
